import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'negativeValueTransform'
})
export class NegativeValueTransformPipe implements PipeTransform {

  transform(value: number | string | null): string  {
    let numberValue = typeof value == 'string' ? parseFloat(value) : value
    if (numberValue && numberValue < 0) {
      return `(${Math.abs(numberValue)})`;
    }else if(numberValue==0){
      return numberValue.toString();
    }
    return  numberValue?Math.abs(numberValue)?.toString():"";
  }
}
